import { h } from 'vue';
import { openPanel } from '@/layouts/layouts';
import ReportViewer from "@/components/ReportViewer";
import { reportData } from '@/api/reports';

export async function report(caption: string, reportName: string, params: any) {
	try {
		const dataset: any = await reportData(reportName, params);

		openPanel({
			caption,
			onCreate: (panel: any) => ({ component: h(ReportViewer, { panel, dataset, reportName }) })
		})
	} catch (error: any) {
		console.error(error.message);
	}
}
	